<script>
  import { Modal, ModalHeader, ModalBody, ModalFooter } from "sveltestrap";
  import alertify from "alertifyjs";
  import backend from "../../../../server";

  export let client;
  export let open = false;

  let loading = false;
  let saving = false;
  let providers = [];
  let selectedProvider = "";
  let currentProvider = null;
  let loadedClientCode = null;

  $: if (open && client?.code && loadedClientCode !== client.code) {
    loadData();
  }

  async function loadData() {
    if (!client?.code || loading) return;
    loadedClientCode = client.code;
    loading = true;
    try {
      const [providerResponse, currentResponse] = await Promise.all([
        backend.provider.listProvidersByCategoryOrType({ category: "sportbook" }),
        backend.client.getSportbookProvider(client.code),
      ]);

      providers = Array.isArray(providerResponse?.data)
        ? providerResponse.data.filter(Boolean).sort((a, b) => String(a).localeCompare(String(b)))
        : [];

      currentProvider = currentResponse?.data?.provider || null;
      selectedProvider = currentProvider || "";

      if (currentProvider && !providers.includes(currentProvider)) {
        providers = [...providers, currentProvider].sort((a, b) => String(a).localeCompare(String(b)));
      }
    } catch (error) {
      alertify.error("No se pudo cargar la configuración");
    } finally {
      loading = false;
    }
  }

  async function save() {
    if (!client?.code || saving) return;
    saving = true;
    try {
      const response = await backend.client.saveSportbookProvider(client.code, {
        provider: selectedProvider || null,
      });
      currentProvider = response?.data?.provider || null;
      selectedProvider = currentProvider || "";
      alertify.success("Configuración guardada");
      close();
    } catch (error) {
      alertify.error("No se pudo guardar la configuración");
    } finally {
      saving = false;
    }
  }

  function close() {
    open = false;
    loading = false;
    saving = false;
    providers = [];
    selectedProvider = "";
    currentProvider = null;
    loadedClientCode = null;
  }
</script>

<Modal isOpen={open} toggle={close}>
  <ModalHeader toggle={close}>
    Configurar sportbook: {client?.namesite || client?.businessname || client?.code || ""}
  </ModalHeader>
  <ModalBody>
    <div class="form-group">
      <label><b>Código</b></label>
      <input class="form-control" value={client?.code || ""} disabled />
    </div>

    <div class="form-group">
      <label><b>Deportiva actual</b></label>
      <input class="form-control" value={currentProvider || "Sin asignar"} disabled />
    </div>

    <div class="form-group">
      <label><b>Seleccionar deportiva</b></label>
      <select class="form-control" bind:value={selectedProvider} disabled={loading || saving}>
        <option value="">Sin asignar</option>
        {#each providers as provider}
          <option value={provider}>{provider}</option>
        {/each}
      </select>
    </div>

    {#if loading}
      <div class="helper">Cargando configuración...</div>
    {/if}
  </ModalBody>
  <ModalFooter>
    <button class="btn btn-secondary btn-sm" on:click={close} disabled={saving}>Cerrar</button>
    <button class="btn btn-primary btn-sm" on:click={save} disabled={loading || saving}>
      {saving ? "Guardando..." : "Guardar"}
    </button>
  </ModalFooter>
</Modal>

<style>
  .form-group {
    margin-bottom: 1rem;
  }

  .helper {
    color: #6c757d;
    font-style: italic;
  }
</style>
